// extracted by mini-css-extract-plugin
export default {"container":"B8VWG4IrkrCAW6O32Z5a","h1Error":"VQqsSFqEG82faiAeaONl","h1Warning":"sbkIIqOuBZwqloaYADGg","h1Success":"FAtQPwTnr2SJtXBzriLD","pulse":"rCHqIc_so2327YBqFRUC"};